import * as formik from "formik";
import { useField } from "formik";
import { useCallback, useEffect, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { FormRadio, radioDataType } from "../FormRadio/FormRadio";
import { Notification } from "../Notification/Notification";
import { ToastContent } from "../Notification/types";
import iconImage from "./ic_launcher.png";
import { PushNotificationType } from "../_shared/pushNotifications/types";
import { MdSignalCellular3Bar } from "react-icons/md";
import { MdBattery30 } from "react-icons/md";
import { MdNetworkWifi } from "react-icons/md";
import "./NewPushNotification.css";
import "./notification-form.css";

import {
  convertDateStrings,
  createDeeplinkList,
  notificationSchema,
} from "./utils";
import {
  CreatePushNotificationMutationVariables,
  Messages,
  useCreatePushNotificationMutation,
  useGetMessagesQuery,
} from "../../graphql/generated/graphql";
import { BackButton } from "../_shared/Buttons/BackButton";
import { Heading } from "@aws-amplify/ui-react";

export type DeepLinkList = {
  id: string;
  Title: string;
};

export const NewPushNotifiction = () => {
  const NotificationPreview = ({
    title,
    body,
    time,
    date,
  }: {
    title: string;
    body: string;
    time: string;
    date: string;
  }) => (
    <div style={{ display: "flex", margin: "auto" }}>
      <div className="phone-mockup">
        <div className="status-bar">
          <div className="status-bar-time">{time}</div>
          <div className="status-icons">
            <MdNetworkWifi />
            <MdSignalCellular3Bar />
            <MdBattery30 />
          </div>
        </div>
        <div className="android-time">{time}</div>
        {/* Notification Card */}
        <div className="date-text">{date}</div>
        <div className="notification-card">
          {/* Notification Icon */}
          <img src={iconImage} alt="icon" className="notification-icon" />

          {/* Notification Text */}
          <div className="notification-content">
            <div className="notification-title">
              {title || ""} <span>{time || "11:55"}</span>
            </div>
            <div className="notification-body">{body || ""}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const [notification, setNotification] = useState<PushNotificationType>({
    id: uuidv4(),
    name: "",
    title: "",
    body: "",
    deeplink: "",
    dueOn: new Date().toISOString(),
    throttleRate: 30,
    autoPauseSchedule: false,
    pauseSendingTime: "",
    resumeSendingTime: "",
    application: "TRAVELAPP",
    tmcUsers: "",
    tiUsers: "",
    deviceOS: "",
    status: "SCHEDULED",
  });

  const { Formik } = formik;
  const [createPushNotification] = useCreatePushNotificationMutation();
  const [tmcUsersInfo, setTmcUsersInfo] = useState("n/a");
  const [tiUsersInfo, setTiUsersInfo] = useState("n/a");
  const [deviceOSInfo, setDeviceOSInfo] = useState<"android" | "ios" | "both">(
    "both"
  );
  const [previewBody, setPreviewBody] = useState<string>("");
  const [preveiwTitle, setPreviewTitle] = useState<string>("");
  const { data: messagesData } = useGetMessagesQuery();

  const [deeplinkMessages, setDeeplinkMessages] = useState(
    [] as DeepLinkList[]
  );

  const [toast, setToast] = useState<ToastContent>({
    title: "",
    description: "",
    isVisible: false,
    notificationVariant: "success",
  });

  const [disableSubmitBtn, setDisableSubmitBtn] = useState<boolean>(false);

  const timeout: number = 4000;
  const navigate = useNavigate();

  const handleMessages = useCallback(async () => {
    try {
      if (messagesData?.getMessages) {
        console.log(`checking messages data ${JSON.stringify(messagesData)}`);
        const deeplinkList = await createDeeplinkList(
          messagesData.getMessages as Messages[]
        );
        setDeeplinkMessages(deeplinkList);
      }
    } catch (e) {
      console.log("handleMessages error:", e);
      // signOut or error UI if needed
    }
  }, [messagesData]);

  useEffect(() => {
    handleMessages();
  }, [handleMessages]);

  const DatePickerField = (props: formik.FieldHookConfig<DatePicker>) => {
    const [field, meta, helpers] = useField(props);
    console.log(meta); //added to fix eslint issue to allow deployment
    return (
      <DatePicker
        selected={field.value && new Date(field.value)}
        onChange={(value) => helpers.setValue(value)}
        showMonthPicker
        showTimeInput
        showMonthDropdown
        showYearDropdown
        timeInputLabel="Time:"
        dateFormat="dd/MM/yyyy h:mm aa"
        className="datePicker"
        name="dueOn"
      />
    );
  };

  const handleSubmitNotification = async (values: PushNotificationType) => {
    const time = convertDateStrings(values.dueOn);

    try {
      const variables: CreatePushNotificationMutationVariables = {
        pushNotification: {
          ...values,
          id: uuidv4(),
          scheduleId: undefined,
          dueOn: time,
          tiUsers: tiUsersInfo,
          tmcUsers: tmcUsersInfo,
          deviceOS: deviceOSInfo,
        },
      };

      if (variables.pushNotification["__typename"]) {
        delete variables.pushNotification["__typename"];
      }

      const response = await createPushNotification({ variables });

      if (response.data.createPushNotification.scheduleResponse.scheduleId) {
        setToast({
          title: "Success",
          description: `Notification created. ${response.data.createPushNotification.scheduleResponse.message}`,
          isVisible: true,
          notificationVariant: "success",
        });
        setTimeout(() => {
          navigate(-1);
        }, timeout);
      } else {
        setToast({
          title: "Error!",
          description: `Failed to create notification. ${response.data.createPushNotification.scheduleResponse.message}`,
          isVisible: true,
          notificationVariant: "danger",
        });
        throw new Error("Something went wrong");
      }
    } catch (e) {
      console.log("error is " + JSON.stringify(e));
      throw new Error("Something went wrong");
    }
  };
  const goBack = () => {
    navigate(-1);
  };
  const handleNotificationClose = () => {
    setToast({ ...toast, isVisible: false });
  };

  const radioTMC: radioDataType[] = [
    { radioLabel: "Yes", radioId: "yes", radioName: "tmcUsers" },
    { radioLabel: "N/A", radioId: "n/a", radioName: "tmcUsers" },
    { radioLabel: "No", radioId: "no", radioName: "tmcUsers" },
  ];

  const radioTI: radioDataType[] = [
    { radioLabel: "Yes", radioId: "yes", radioName: "tiUsers" },
    { radioLabel: "N/A", radioId: "n/a", radioName: "tiUsers" },
    { radioLabel: "No", radioId: "no", radioName: "tiUsers" },
  ];
  const radioDevice: radioDataType[] = [
    { radioLabel: "Both", radioId: "both", radioName: "deviceOS" },
    { radioLabel: "IOS Only", radioId: "ios", radioName: "deviceOS" },
    {
      radioLabel: "Android Only",
      radioId: "android",
      radioName: "deviceOS",
    },
  ];

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/push-notification");
  };

  const toastVariant = toast.title === "Error!" ? "danger" : "success";

  return (
    <Container className="new-notification" fluid style={{ marginBottom: 30 }}>
      <Row>
        <Col sm={8}>
          <Formik
            validationSchema={notificationSchema}
            initialValues={notification}
            onSubmit={async (
              values: PushNotificationType,
              { setSubmitting }
            ) => {
              setSubmitting(true);
              setNotification(values);
              await handleSubmitNotification(values)
                .then(() => {
                  setDisableSubmitBtn(true);
                })
                .catch(() => {
                  setSubmitting(false);
                });

              console.log("push values", values);
              console.log("notification values", notification);
            }}
          >
            {({
              handleChange,
              handleSubmit,
              values,
              touched,
              errors,
              handleBlur,
              isSubmitting,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="formContainer">
                  <BackButton
                    onClick={onClick}
                    label={"Back to push notification"}
                  />

                  <div className="formHeader">
                    <Heading level={2} className="screen-title">
                      Add New Notification
                    </Heading>
                    <p className="hint">
                      Create and schedule a push to your users.
                    </p>
                  </div>
                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Notification name
                        <span id="name-hint" className="label__hint">
                          (Internal reference)
                        </span>
                      </Form.Label>
                      <Col sm={9}>
                        <Form.Control
                          name="name"
                          aria-label="Notificaton Name"
                          size="lg"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                          isValid={touched.name && !errors.name}
                          isInvalid={!!errors.name}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>

                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Notification title
                      </Form.Label>
                      <Col sm={9}>
                        <Form.Control
                          name="title"
                          aria-label="Notificaton Title"
                          size="lg"
                          onChange={(event) => {
                            handleChange(event);
                            setPreviewTitle(event.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.title}
                          isValid={touched.title && !errors.title}
                          isInvalid={!!errors.title}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.title}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>

                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Notification body
                      </Form.Label>
                      <Col sm={9}>
                        <Form.Control
                          name="body"
                          aria-label="Notificaton Body"
                          size="lg"
                          onChange={(event) => {
                            handleChange(event);
                            setPreviewBody(event.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.body}
                          isValid={touched.body && !errors.body}
                          isInvalid={!!errors.body}
                          as={"textarea"}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.body}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>
                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Notification deeplink
                      </Form.Label>
                      <Col sm={9}>
                        <Form.Select
                          name="deeplink"
                          aria-label="Deeplink"
                          size="lg"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value={""}>
                            If required please select a message for the
                            notification to navigate too
                          </option>
                          {deeplinkMessages.map((message) => {
                            return (
                              <option value={`message/${message.id}`}>
                                {message.Title}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.deeplink}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>
                  <Row
                    as={"div"}
                    className="formItem"
                    style={{ height: 48, alignItems: "center" }}
                  >
                    <Col xs={3} className="label">
                      <span>Due on</span>
                      <span id="due-hint" className="label__hint">
                        (time is rounded)
                      </span>
                    </Col>

                    <Col xs={9}>
                      <DatePickerField name="dueOn" />
                    </Col>
                  </Row>
                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Throttle rate
                        <span id="throttle-hint" className="label__hint">
                          (number of notifications sent per second)
                        </span>
                      </Form.Label>
                      <Col sm={9} style={{ margin: "auto" }}>
                        <Form.Control
                          name="throttleRate"
                          aria-label="Throttle rate"
                          size="lg"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.throttleRate}
                          isValid={touched.throttleRate && !errors.throttleRate}
                          isInvalid={!!errors.throttleRate}
                        ></Form.Control>
                        <small className="hint">
                          We recommend 20–50 to avoid provider throttling.
                        </small>
                        <Form.Control.Feedback type="invalid">
                          {errors.throttleRate}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>
                  <div className="formItem">
                    <Form.Group as={Row} className="checkContainer">
                      <Form.Label column sm={3} className="label">
                        Automatically pause schedule?
                      </Form.Label>
                      <Col sm={9} style={{ margin: "auto" }}>
                        <Form.Check
                          type="switch"
                          name="autoPauseSchedule"
                          aria-label="Automatically pause schedule"
                          onChange={handleChange}
                          className="checkedInput"
                        />
                      </Col>
                    </Form.Group>
                  </div>
                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Pause sending time
                      </Form.Label>
                      <Col sm={9} style={{ margin: "auto" }}>
                        <Form.Control
                          name="pauseSendingTime"
                          aria-label="Pause sending time"
                          size="lg"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.pauseSendingTime}
                          isValid={
                            touched.pauseSendingTime && !errors.pauseSendingTime
                          }
                          isInvalid={!!errors.pauseSendingTime}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.pauseSendingTime}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>
                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Resume sending time
                      </Form.Label>
                      <Col sm={9} style={{ margin: "auto" }}>
                        <Form.Control
                          name="resumeSendingTime"
                          aria-label="Resume sending time"
                          size="lg"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.resumeSendingTime}
                          isValid={
                            touched.resumeSendingTime &&
                            !errors.resumeSendingTime
                          }
                          isInvalid={!!errors.resumeSendingTime}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.resumeSendingTime}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>

                  <div className="formItem">
                    <Form.Group as={Row}>
                      <Form.Label column sm={3} className="label">
                        Application
                      </Form.Label>
                      <Col sm={9} style={{ margin: "auto" }}>
                        <Form.Control
                          name="application"
                          aria-label="application"
                          size="lg"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.application}
                          isValid={touched.application && !errors.application}
                          isInvalid={!!errors.application}
                          disabled
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.application}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                  </div>

                  <div className="formItem radio-btn">
                    <FormRadio
                      radioData={radioTMC}
                      labelText="TMC users"
                      setInfo={setTmcUsersInfo}
                      defaultValue={tmcUsersInfo}
                    ></FormRadio>
                  </div>
                  <div className="formItem radio-btn">
                    <FormRadio
                      radioData={radioTI}
                      labelText="TI users"
                      setInfo={setTiUsersInfo}
                      defaultValue={tiUsersInfo}
                    ></FormRadio>
                  </div>
                  <div className="formItem radio-btn">
                    <FormRadio
                      radioData={radioDevice}
                      labelText="Device OS"
                      setInfo={setDeviceOSInfo}
                      defaultValue={deviceOSInfo}
                    ></FormRadio>
                  </div>
                  <div className="actions" style={{ zIndex: 1050 }}>
                    <Button
                      variant="primary"
                      className="btn-save"
                      disabled={isSubmitting || disableSubmitBtn}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      variant="outline-secondary"
                      className="tn-cancel"
                      onClick={goBack}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Col>
        <Col>
          <div className="previewContainer">
            <NotificationPreview
              title={preveiwTitle}
              body={previewBody}
              time={new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
              date={new Date().toLocaleDateString([], {
                day: "numeric",
                month: "short",
                weekday: "long",
              })}
            />
          </div>
        </Col>
      </Row>
      <Notification
        show={toast.isVisible}
        timer={timeout}
        position="top-center" // Updated position for consistent positioning
        title={toast.title}
        description={toast.description}
        autohide={true}
        handleClose={handleNotificationClose}
        variant={toastVariant}
      />
    </Container>
  );
};
